import React, { Component } from "react";
import config from "lib/fr-config";
import CommonSplitView from "presentational/common/CommonSplitView";
import ItemUnitListView from "presentational/common/itemUnit/ItemUnitListView";
import ImageOnlyModalView from "presentational/common/modals/ImageOnlyModalView";
import ItemModalView from "presentational/common/modals/ItemModalView";
import OutfitImageView from "presentational/common/OutfitImageView";
import IconButtonView from "presentational/common/IconButtonView";
import DateText from "presentational/common/multinational/DateText";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import styles from "./OutfitSummaryPanelView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const IMAGE_RATIO = config.outfitImage.RATIO;

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const colorCss = config.css.color;

const cssXL = {
  buttonArea: {
    marginBottom: desktopCss.standardPaddingBetweenContent
  },
  calendarInfoArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginBottom: 20
  }
};
const cssXS = {
  imageFrame: {
    backgroundColor: colorCss.colorOfBackground,
    position: "sticky",
    top: 0,
    zIndex: 1200
  },
  imageWrapper: {
    marginTop: -mobileCss.paddingBetweenHeaderbarAndFirstContent,
    width: "40%",
    paddingBottom:
      mobileCss.paddingBetweenHeaderbarAndFirstContentForOutfitUpload
  },
  buttonArea: {
    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`
  },
  buttonWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom))"
  },
  calendarInfoArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginBottom: 20
  }
};

class OutfitSummaryPanelView extends Component {
  static propTypes = {
    stickeredImageDataURL: PropTypes.string.isRequired,
    itemList: PropTypes.array.isRequired,
    calendarDate: PropTypes.string.isRequired,
    calendarAgreement: PropTypes.bool.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onSubmitClick: PropTypes.func.isRequired
  };

  state = {
    imageModalOpen: false,

    itemInfo: null,
    itemModalOpen: false
  };

  getWidthOfLeftSide = fixedHeightValue => {
    const { innerHeight } = window;
    const imageHeight = innerHeight - fixedHeightValue;
    return imageHeight * IMAGE_RATIO;
  };

  handleImageModalOpen = () => {
    this.setState({ imageModalOpen: true });
  };

  handleImageModalClose = () => {
    this.setState({ imageModalOpen: false });
  };

  handleItemClick = itemInfo => {
    this.setState({ itemModalOpen: true, itemInfo });
  };

  handleItemModalClose = () => {
    this.setState({ itemModalOpen: false });
  };

  mobileLayout() {
    const {
      stickeredImageDataURL,
      itemList,
      calendarDate,
      calendarAgreement,
      onBackClick,
      onSubmitClick
    } = this.props;
    const { imageModalOpen, itemInfo, itemModalOpen } = this.state;
    const css = cssXS;

    return (
      <div className={cx("root", "mobile")}>
        <div style={css.imageFrame}>
          <div
            className={cx("image-wrapper")}
            onClick={this.handleImageModalOpen}
            style={css.imageWrapper}
          >
            <OutfitImageView imageSrc={stickeredImageDataURL} />
          </div>
        </div>
        <ImageOnlyModalView
          open={imageModalOpen}
          imageRatio={IMAGE_RATIO}
          imageSrc={stickeredImageDataURL}
          onClose={this.handleImageModalClose}
        />
        <div>
          <div style={css.calendarInfoArea}>
            <DateText
              inputType={"fullDateText"}
              outputType={"outputYMD"}
              fullDateText={calendarDate}
              displayWeekday={true}
            />
            {calendarAgreement && (
              <div>
                <TXT name="msg_displayCalendar" />
              </div>
            )}
          </div>
          <ItemUnitListView
            itemList={itemList}
            onItemClick={this.handleItemClick}
          />
        </div>
        {itemInfo && (
          <ItemModalView
            open={itemModalOpen}
            itemInfo={itemInfo}
            onClose={this.handleItemModalClose}
            disableButtons
          />
        )}
        <div className={cx("button-area")} style={css.buttonArea}>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"back"} onClick={onBackClick} />
          </div>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"submit"} onClick={onSubmitClick} />
          </div>
        </div>
      </div>
    );
  }

  desktopLayout() {
    const {
      stickeredImageDataURL,
      itemList,
      calendarDate,
      calendarAgreement,
      onBackClick,
      onSubmitClick
    } = this.props;
    const { imageModalOpen, itemInfo, itemModalOpen } = this.state;
    const css = cssXL;

    return (
      <div className={cx("root", "desktop")}>
        <CommonSplitView
          getWidthOfLeftSide={this.getWidthOfLeftSide}
          leftSideComponent={
            <div>
              <div
                className={cx("image-wrapper")}
                onClick={this.handleImageModalOpen}
              >
                <OutfitImageView imageSrc={stickeredImageDataURL} />
              </div>
              <ImageOnlyModalView
                open={imageModalOpen}
                imageRatio={IMAGE_RATIO}
                imageSrc={stickeredImageDataURL}
                onClose={this.handleImageModalClose}
              />
            </div>
          }
          rightSideComponent={
            <div>
              <div className={cx("button-area")} style={css.buttonArea}>
                <IconButtonView type={"back"} onClick={onBackClick} />
                <IconButtonView
                  type={"submit"}
                  disableRightMargin
                  onClick={onSubmitClick}
                />
              </div>
              <div>
                <div style={css.calendarInfoArea}>
                  <DateText
                    inputType={"fullDateText"}
                    outputType={"outputYMD"}
                    fullDateText={calendarDate}
                    displayWeekday={true}
                  />
                  {calendarAgreement && (
                    <div>
                      <TXT name="msg_displayCalendar" />
                    </div>
                  )}
                </div>
                <ItemUnitListView
                  itemList={itemList}
                  onItemClick={this.handleItemClick}
                />
              </div>
            </div>
          }
        />
        {itemInfo && (
          <ItemModalView
            open={itemModalOpen}
            itemInfo={itemInfo}
            onClose={this.handleItemModalClose}
            disableButtons
          />
        )}
      </div>
    );
  }

  render() {
    return getDeviceType() === "mobile"
      ? this.mobileLayout()
      : this.desktopLayout();
  }
}

export default OutfitSummaryPanelView;
